export default __webpack_public_path__ + "img/landscape_3.fbf73255705d1e2d3304c860832acbac.jpg";